import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdminService } from '../admin.service';
import { LogEvent } from './logEvent.model';
import { AdminConst } from '../const';
import { CoreService } from '../../../core/header/core.service';
import { DummyComponent } from '../../../shared/dummy.component';

@Component({
    selector: 'convfact-adminevent-list',
    templateUrl: './event-list.component.html',
    styleUrls: ['./event.component.css'],
    standalone: false
})

export class AdminEventListComponent implements OnInit {
  eventsList: LogEvent[] = [];
  isAdmin = false;
  readyEvents: boolean = false;

  headerTableEvents: any[] = AdminConst.headerTableEvents;

  constructor(
    private coreService: CoreService,
    private router: Router,
    public snackBar: MatSnackBar,
    private adminService: AdminService,
    public dialog: MatDialog,
    public dummy: DummyComponent
  ) { }

  ngOnInit() {
    this.coreService.setName('Panel de administración');
    this.isAdmin = false;

    this.adminService.GetLogEvent().then(
      result => {
        this.readyEvents = true;
        this.eventsList = result;
        this.isAdmin = true;
      }, data => {
        this.router.navigate(['/resume']);
      }
    );
  }

  cleanEvents(){
    this.adminService.CleanEvents().then(result=>{
      this.dummy.redirectTo(this.router.url);
    },data => {  
      this.router.navigate(['/resume']);
    })
  } 
}
